export default "__VITE_ASSET__DBMJ1feq__"